import type { Installation } from "@sitescene/types";

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

/** POST /shadow/installations body (matches createInstallationSchema). */
export type CreateInstallationRequest = {
	externalId: string;
	location: string;
};

/**
 * Shadow Realm installations API (org via `X-Shadow-Org` on the client).
 */
export const installationsApi = {
	createInstallation: async (
		body: CreateInstallationRequest,
	): Promise<Installation> => {
		const response = await apiClient.post<Installation>(
			ENDPOINTS.shadow.installations.create,
			body,
		);
		return response.data;
	},

	getInstallations: async (): Promise<Installation[]> => {
		const response = await apiClient.get<Installation[]>(
			ENDPOINTS.shadow.installations.list,
		);
		return response.data;
	},
};
